var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0421\\u043B\\u043E\\u0439_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 22 22",
    style: {
      enableBackground: "new 0 0 22 22"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#827F83;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u0421\\u043B\\u043E\\u0439_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.7,22c-2.8,0-6.8-0.9-10.8-4.9C0.7,12.9-0.1,8.7,0,5.8c0.1-1.5,0.8-3,2.2-4.4C3.3,0.4,4.8-0.2,6.3,0 C7.6,0.2,8.7,1,9.4,2.1l0.8,1.5c0.9,1.7,0.6,3.9-0.9,5.3c-0.2,0.3-0.3,1.2,1.1,2.6c1.4,1.4,2.3,1.4,2.6,1.1 c1.5-1.4,3.6-1.8,5.3-0.9l1.5,0.8c1.1,0.6,1.9,1.8,2.1,3.1c0.2,1.4-0.3,3-1.4,4.1c-1.4,1.4-2.9,2.1-4.4,2.2C16,22,15.8,22,15.7,22 L15.7,22z M5.7,1.9c-0.8,0-1.5,0.3-2.1,0.9C2.8,3.5,2,4.6,1.9,5.9C1.8,8.3,2.5,12,6.2,15.8c3.7,3.7,7.4,4.4,9.9,4.3 c1.3,0,2.4-0.9,3.1-1.6c0.7-0.7,1-1.6,0.9-2.5c-0.1-0.8-0.5-1.4-1.1-1.7l-1.5-0.8c-1-0.5-2.2-0.3-3.1,0.6l0,0 c-0.3,0.3-0.8,0.5-1.3,0.6c-0.9,0.1-2.2-0.1-4-1.8C6,9.7,7.9,7.7,8,7.6c0.9-0.9,1.1-2.1,0.6-3.1L7.7,3C7.4,2.4,6.8,2,6,1.9 C5.9,1.9,5.8,1.9,5.7,1.9L5.7,1.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.abf76ead17f74ff9d502d262a5d6a3e6.svg";
export { ForwardRef as ReactComponent };